import React, { useState } from 'react';
import { Button } from '../common/Button';
import { Input } from '../common/Input';

export const AffiliateContactForm: React.FC = () => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSending(true);
    
    // Simulate sending email
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // TODO: Implement actual email sending logic (e.g., via Cloud Function)
    // console.log('Sending affiliate support email:', { subject, message });
    
    setSending(false);
    setSent(true);
    setSubject('');
    setMessage('');
  };

  if (sent) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
        <h3 className="text-lg font-medium text-green-800 mb-2">Message Sent!</h3>
        <p className="text-green-600 mb-4">
          Thank you for contacting us. Our affiliate team will get back to you shortly.
        </p>
        <Button onClick={() => setSent(false)} variant="outline">
          Send another message
        </Button>
      </div>
    );
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-neutral-200">
      <h3 className="text-lg font-semibold text-neutral-900 mb-4">Contact Affiliate Support</h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="subject" className="block text-sm font-medium text-neutral-700 mb-1">
            Subject
          </label>
          <Input
            id="subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="Payment question, technical issue, etc."
            required
          />
        </div>
        
        <div>
          <label htmlFor="message" className="block text-sm font-medium text-neutral-700 mb-1">
            Message
          </label>
          <textarea
            id="message"
            rows={4}
            className="block w-full rounded-md border-neutral-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="How can we help you?"
            required
          />
        </div>

        <div className="flex justify-end">
          <Button type="submit" loading={sending}>
            Send Message
          </Button>
        </div>
      </form>
    </div>
  );
};
